import { Input, Button } from 'antd';
import styled, { css } from 'react-emotion';

export const Fields = styled(Input.Group)`
  .ant-btn {
    span {
      /* IE11 Doesn't handle text truncation very well, so we're using this as a workaround. */
      width: calc(100% - 0.7rem);
      overflow: hidden;
      text-align: left;
      text-overflow: ellipsis;
      vertical-align: bottom;
    }
    .anticon {
      font-size: 12px;
    }
  }
`;

export const popup = css`
  .ant-btn-block {
    margin-top: 0.5rem;
  }
  .ant-input-group {
    width: 260px;
  }
  .ant-input-number, .ant-time-picker, .ant-date-picker, .ant-input-group-wrapper {
    display: block;
    transition-property: none;
  }
  .ant-select-selection-selected-value {
    padding-right: 10px;
  }
  .ant-popover-inner-content {
    padding: 0;
  }
  .ant-divider-horizontal {
    margin-bottom: 0px;
  }
`;

export const popupChild = children => css`
  .ant-input-group {
    width: ${children > 4 ? 1000 : children * 250}px;
    padding: 12px 16px;
  }
`;

export const EmptyField = styled('span')`
  color: #999;
`;

export const ValueModifier = styled('div')`
  > * {
    margin-top: 0.7rem;
  }
`;

export const ValueSelect = styled('div')`
  padding: 12px 16px;
`;

export const saveWidth = 100;

export const Save = styled(Button)`
  width: ${`${saveWidth}px`};
`;
export const fieldsWidth = cols => `calc(${100 / cols.length}% - ${saveWidth / cols.length}px)`;
